import { combineEpics } from 'redux-observable';
import { closeSymbolLpBeforeRemoveEpic } from './_epics/closeSymbolLpBeforeRemove.epic';
import { handleSymbolLpNotFoundEpic } from './_epics/handleSymbolLpNotFound.epic';
import { reloadSymbolLpListEpic } from './_epics/reloadSymbolLpList.epic';
import { toggleViewSymbolLpSidebarEpic } from './_epics/toggleViewSymbolLpSidebar.epic';
import { closeBulkEditSidebarOnDoneEpic } from './_epics/closeBulkEditSidebarOnDone.epic';

export const controllerSymbolLpEpic = combineEpics(
  closeSymbolLpBeforeRemoveEpic,
  handleSymbolLpNotFoundEpic,
  reloadSymbolLpListEpic,
  toggleViewSymbolLpSidebarEpic,
  closeBulkEditSidebarOnDoneEpic,
);
